import {FETCH_HW_FIND_US,CREATE_HW_FIND_US,UPDATE_HW_FIND_US,DELETE_HW_FIND_US,DELETE_M_HW_FIND_US} from '../actions';
const initialState = {
    // deleted:null,
    selectedToDelete: null,
    newHwType: null,
    updatedHwType: null,
    hwTypes: [],
    loading: false,
    newHwFindUSError:null,
    fetchHwFindUSError:null,
    updateHwFindUSError:null,
    deleteHwFindUSError:null,
    deleteMHwFindUSError:null
  }

function howFindUsReducer(state = initialState, action){
    let selectedToDelete, 
    newHwType,
    updatedHwType, 
    hwTypes;
    
    switch(action.type){
        case `${FETCH_HW_FIND_US}_PENDING`:
        case `${CREATE_HW_FIND_US}_PENDING`:
        case `${UPDATE_HW_FIND_US}_PENDING`:
        case `${DELETE_HW_FIND_US}_PENDING`:
        case `${DELETE_M_HW_FIND_US}_PENDING`:
            return { ...state, loading: true};

            
        case `${FETCH_HW_FIND_US}_FULFILLED`:
            hwTypes = action.payload.data;
            return {...state, loading:false, hwTypes};
        case `${CREATE_HW_FIND_US}_FULFILLED`:
            newHwType = action.payload.data;
            return {...state, loading:false, newHwType};
        case `${UPDATE_HW_FIND_US}_FULFILLED`:
            updatedHwType = action.payload.data;
            return {...state, loading:false, updatedHwType};
        case `${DELETE_HW_FIND_US}_FULFILLED`:
            selectedToDelete = action.payload.data;
            return {...state, loading:true, selectedToDelete};
        case `${DELETE_M_HW_FIND_US}_FUlFILLED`:
            selectedToDelete = action.payload.data;
            return { ...state, loading: false, selectedToDelete };


        case `${FETCH_HW_FIND_US}_REJECTED`:
            return {...state, loading: false, fetchHwFindUSError: `${action.payload.message}`, state: initialState };
        case `${CREATE_HW_FIND_US}_REJECTED`:
            return {...state, loading: false, newHwFindUSError: `${action.payload.message}`, state: initialState };
        case `${UPDATE_HW_FIND_US}_REJECTED`:
            return {...state, loading: false, updateHwFindUSError: `${action.payload.message}`, state: initialState };
        case `${DELETE_HW_FIND_US}_REJECTED`:
            return {...state, loading: false, deleteHwFindUSError: `${action.payload.message}`, state: initialState };
        case `${DELETE_M_HW_FIND_US}_REJECTED`:
            return {...state, loading: false, deleteMHwFindUSError: `${action.payload.message}`, state: initialState };

        default:
        return state;
    }
}
export default howFindUsReducer;
